import ActivateKitButton from './ActivateKitButton'

export default ActivateKitButton
